import { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { categories } from '@/mocks/comics';

export default function Navbar() {
  const [searchOpen, setSearchOpen] = useState(false);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const [searchQuery, setSearchQuery] = useState('');
  const location = useLocation();

  const isHome = location.pathname === '/';

  return (
    <nav className={`w-full z-50 transition-all duration-300 ${isHome ? 'absolute top-0 left-0 bg-transparent' : 'sticky top-0 bg-background-50/95 backdrop-blur-sm border-b border-background-200/70'}`}>
      <div className="w-full px-4 md:px-6">
        <div className="flex items-center justify-between h-16">
          <Link to="/" className="flex items-center gap-3 whitespace-nowrap cursor-pointer">
            <div className="w-9 h-9 flex items-center justify-center">
              <i className={`ri-book-read-line text-2xl ${isHome ? 'text-white' : 'text-primary-500'}`}></i>
            </div>
            <span className={`font-heading font-bold text-xl tracking-wide ${isHome ? 'text-white' : 'text-foreground-950'}`}>虚空韩漫</span>
          </Link>

          <div className="hidden md:flex items-center gap-1">
            <Link
              to="/"
              className={`px-4 py-2 rounded-lg text-sm font-medium transition-colors whitespace-nowrap cursor-pointer ${location.pathname === '/' ? (isHome ? 'text-white bg-white/20' : 'text-primary-500 bg-primary-50') : (isHome ? 'text-white/80 hover:text-white hover:bg-white/10' : 'text-foreground-700 hover:text-foreground-950 hover:bg-background-100')}`}
            >
              首页
            </Link>
            {Object.entries(categories).filter(([k]) => k !== 'all').map(([slug, cat]) => (
              <Link
                key={slug}
                to={`/category/${slug}`}
                className={`px-4 py-2 rounded-lg text-sm font-medium transition-colors whitespace-nowrap cursor-pointer ${location.pathname === `/category/${slug}` ? (isHome ? 'text-white bg-white/20' : 'text-primary-500 bg-primary-50') : (isHome ? 'text-white/80 hover:text-white hover:bg-white/10' : 'text-foreground-700 hover:text-foreground-950 hover:bg-background-100')}`}
              >
                {cat.name}
              </Link>
            ))}
            <Link
              to="/about"
              className={`px-4 py-2 rounded-lg text-sm font-medium transition-colors whitespace-nowrap cursor-pointer ${location.pathname === '/about' ? (isHome ? 'text-white bg-white/20' : 'text-primary-500 bg-primary-50') : (isHome ? 'text-white/80 hover:text-white hover:bg-white/10' : 'text-foreground-700 hover:text-foreground-950 hover:bg-background-100')}`}
            >
              关于我们
            </Link>
          </div>

          <div className="hidden md:flex items-center gap-3">
            <div className="relative">
              {searchOpen ? (
                <div className="flex items-center gap-2">
                  <input
                    type="text"
                    value={searchQuery}
                    onChange={(e) => setSearchQuery(e.target.value)}
                    placeholder="搜索漫画..."
                    className={`w-48 px-4 py-2 text-sm rounded-full border outline-none transition-all ${isHome ? 'bg-white/10 border-white/20 text-white placeholder:text-white/50 focus:border-white/40' : 'bg-background-100 border-background-200 text-foreground-950 placeholder:text-foreground-400 focus:border-primary-300'}`}
                    autoFocus
                    onBlur={() => { if (!searchQuery) setSearchOpen(false); }}
                    onKeyDown={(e) => { if (e.key === 'Escape') { setSearchOpen(false); setSearchQuery(''); } }}
                  />
                  <button
                    onClick={() => { setSearchOpen(false); setSearchQuery(''); }}
                    className={`w-8 h-8 flex items-center justify-center rounded-full cursor-pointer ${isHome ? 'text-white/70 hover:text-white' : 'text-foreground-500 hover:text-foreground-950'}`}
                  >
                    <i className="ri-close-line"></i>
                  </button>
                </div>
              ) : (
                <button
                  onClick={() => setSearchOpen(true)}
                  className={`w-9 h-9 flex items-center justify-center rounded-full transition-colors cursor-pointer ${isHome ? 'text-white/80 hover:text-white hover:bg-white/10' : 'text-foreground-500 hover:text-foreground-950 hover:bg-background-100'}`}
                >
                  <i className="ri-search-line text-lg"></i>
                </button>
              )}
            </div>
          </div>

          <button
            onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
            className={`md:hidden w-9 h-9 flex items-center justify-center rounded-lg cursor-pointer ${isHome ? 'text-white' : 'text-foreground-950'}`}
          >
            <i className={`text-xl ${mobileMenuOpen ? 'ri-close-line' : 'ri-menu-line'}`}></i>
          </button>
        </div>
      </div>

      {mobileMenuOpen && (
        <div className="md:hidden bg-background-50 border-t border-background-200/70 px-4 py-4 flex flex-col gap-2">
          <div className="relative mb-2">
            <input
              type="text"
              value={searchQuery}
              onChange={(e) => setSearchQuery(e.target.value)}
              placeholder="搜索漫画..."
              className="w-full px-4 py-2.5 text-sm rounded-lg border border-background-200 bg-background-100 text-foreground-950 placeholder:text-foreground-400 outline-none focus:border-primary-300"
            />
          </div>
          <Link to="/" onClick={() => setMobileMenuOpen(false)} className={`px-4 py-2.5 rounded-lg text-sm font-medium whitespace-nowrap cursor-pointer ${location.pathname === '/' ? 'text-primary-500 bg-primary-50' : 'text-foreground-700 hover:bg-background-100'}`}>首页</Link>
          {Object.entries(categories).filter(([k]) => k !== 'all').map(([slug, cat]) => (
            <Link key={slug} to={`/category/${slug}`} onClick={() => setMobileMenuOpen(false)} className={`px-4 py-2.5 rounded-lg text-sm font-medium whitespace-nowrap cursor-pointer ${location.pathname === `/category/${slug}` ? 'text-primary-500 bg-primary-50' : 'text-foreground-700 hover:bg-background-100'}`}>{cat.name}</Link>
          ))}
          <Link to="/about" onClick={() => setMobileMenuOpen(false)} className={`px-4 py-2.5 rounded-lg text-sm font-medium whitespace-nowrap cursor-pointer ${location.pathname === '/about' ? 'text-primary-500 bg-primary-50' : 'text-foreground-700 hover:bg-background-100'}`}>关于我们</Link>
        </div>
      )}
    </nav>
  );
}